import empty from "../../static/1x1_trans.png";
import { flags } from "./flags";

interface FlagProps {
  culture: string;
}

const Flag = ({ culture }: FlagProps) => {
  const flag = flags[`flag_${culture.replace("-", "_").toLowerCase()}`];
  const width = 30;

  if (!flag) {
    return <img width={width} alt={culture} src={empty} />;
  }

  return <img width={width} alt={culture} src={flag} />;
};

export default Flag;
